export default "__VITE_ASSET__i7n54IMZ__"